import { CSSProperties } from "react";
import Icon from "elements/Icon";
import Sty from "modules/Sty";
import Colors from "modules/Colors";
import { clsx, styx } from "modules/Utils";
import InputSymphony from "elements/InputSymphony";
import SwitchSymphony from "elements/SwitchSymphony";

export interface PlatformItem {
    title: string;
    description: string;
    name: string;
    icon: string;
    link: string;
    isEnabled: boolean;
    placeholder: string;
}

interface PlatformLinkProps {
    className: string;
    style?: CSSProperties;
    title: string;
    description: string;
    icon: string;
    link: string;
    isEnabled: boolean;
    placeholder: string;
    isRow?: boolean;
    isIcon?: boolean;
    isLabel?: boolean;
    onChange: (value: string) => void;
    onChangeTitle?: (value: string) => void;
    onRemove?: () => void;
    onToggleEnabled: (value: boolean) => void;
    onBlur?: (value: string) => void;
}

const PlatformLink = ({
    className,
    style,
    title,
    description,
    icon,
    link,
    isEnabled,
    placeholder,
    isRow = false,
    isIcon = true,
    isLabel = true,
    onChange,
    onChangeTitle,
    onRemove,
    onToggleEnabled,
    onBlur,
}: PlatformLinkProps) => {
    return (
        <div
            className={clsx('platformLinkElement', className)}
            style={styx(sty.platformLinkElement, style)}
        >
            <div className="platformLinkIcon" style={sty.platformLinkIcon}>
                {isIcon &&
                    <Icon
                        className="platformLinkIcon"
                        icon={icon}
                        size={40}
                    />
                }
                {onChange ?
                    <div
                        className="platformLinkInputContainer"
                        style={styx(
                            sty.platformLinkInputContainer,
                            isRow && { flexDirection: 'row' }
                        )}
                    >
                        {onChangeTitle &&
                            <InputSymphony
                                label="Title"
                                className="platformLinkInput"
                                value={title}
                                onChange={(value) => onChangeTitle(value)}
                                placeholder={placeholder}
                            />
                        }
                        <InputSymphony
                            label={isLabel ? `${title} Link` : ''}
                            className="platformLinkInput"
                            value={link}
                            onChange={(value) => onChange(value)}
                            placeholder={placeholder}
                            onBlur={(value: string) => onBlur?.(value)}
                        />
                    </div>
                    :
                    <div className="platformLinkIconText">
                        <div className="platformLinkIconTextTitle">
                            {title}
                        </div>
                        <div
                            className="platformLinkIconTextDescription"
                            style={Sty.text14grey}
                        >
                            {description}
                        </div>
                    </div>
                }
                {onRemove &&
                    <Icon
                        className="platformLinkRemoveIcon"
                        icon="closeCircle"
                        size={24}
                        onClick={onRemove}
                        color={Colors.greyDark}
                    />
                }
                <SwitchSymphony
                    className="platformLinkSwitch"
                    checked={isEnabled}
                    onChange={(value) => onToggleEnabled(value)}
                    style={{ marginLeft: 'auto' }}
                />
            </div>
            {/* {isEnabled &&
                <InputSymphony
                    className="platformLinkInput"
                    value={link}
                    onChange={(value) => onChange(value)}
                    placeholder={placeholder}
                    label="Update or edit a link"
                />
            } */}
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    platformLinkElement: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        width: '100%',
    },
    platformLinkIcon: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        width: '100%',
    },
    platformLinkInputContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        width: '100%',
    }
}

export default PlatformLink;